import React from 'react';
import {useTranslation} from 'react-i18next';
import {BellSlash} from '../../icons';
import {ALERT_FILTERS, FILTER_ALL} from '../../client/panel_v11/alerts/clientAlertsLogic';

// Contador que acompaña a cada chip: el mismo número que el KPI de arriba, para que prender un
// filtro nunca sorprenda.
const CHIP_COUNT = {
    todas: 'active',
    criticas: 'critic',
    hoy: 'today',
    'se-repiten': 'repeated',
    silenciadas: 'snoozed',
};

/**
 * Los chips de filtro de una bandeja de alertas (Todas · Críticas · Hoy · Se repiten · Silenciadas)
 * y «Silenciar todas» / «Silenciar estas N». Salió de `ClientAlertsView` para «Ahora» (F3).
 *
 * `snoozeable`: las filas visibles que se pueden silenciar; sin ninguna, no hay botón. `children`
 * (opcional) va después de los chips: el «Por regla» de «Ahora». `countInLabel`: el botón dice
 * cuántas silencia también con «Todas» — en «Ahora» son las de todos los clientes, y «Silenciar todas»
 * a secas no deja ver el tamaño del gesto.
 */
export function AlertsToolbar({filter, summary, onChangeFilter, snoozeable, onSnoozeAll, children = null,
                                  countInLabel = false}) {
    const {t} = useTranslation();
    return (
        <div className="cav-toolbar">
            <div className="cav-chips">
                {ALERT_FILTERS.map((key) => {
                    const count = summary[CHIP_COUNT[key]];
                    const isOn = filter === key;
                    return (
                        // Un chip en 0 no se esconde (aparecer y desaparecer se lee como estado del
                        // botón): queda deshabilitado, salvo que esté prendido — hay que poder apagarlo.
                        <button type="button" key={key}
                                className={`cav-chip${isOn ? ' -on' : ''}`}
                                disabled={!isOn && count === 0 && key !== FILTER_ALL}
                                aria-pressed={isOn}
                                onClick={() => onChangeFilter(isOn ? FILTER_ALL : key)}>
                            {t(`client_alerts.filter_${key.replace(/-/g, '_')}`)}
                            <span className="cav-chip__count">{count}</span>
                        </button>
                    );
                })}
                {children}
            </div>
            {snoozeable.length > 0 && (
                <button type="button" className="cav-btn" onClick={() => onSnoozeAll(snoozeable)}>
                    <BellSlash size={13} weight="bold"/>
                    {filter === FILTER_ALL && !countInLabel
                        ? t('clients_v2.alerts_snooze_all')
                        : t('client_alerts.snooze_filtered', {count: snoozeable.length})}
                </button>
            )}
        </div>
    );
}
